










import _ from 'lodash'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class HeaderForm extends Vue {
  @Prop({ default: null }) protected header!: string
}
